import $ from 'jquery';

const $askQuestionOpenButton = $('.ask_question__toggle');
const $askQuestionBanner = $('.ask_question__inner');

const init = () => {
    $askQuestionOpenButton.on('click', () => {
        if ($askQuestionBanner.hasClass('animated')) {
            return;
        }

        $askQuestionOpenButton.toggleClass('ask_question__toggle--close');

        if (!$askQuestionBanner.hasClass('active')) {
            $askQuestionBanner.addClass(['animated', 'fade_in', 'active']).on('animationend', () => {
                $askQuestionBanner.removeClass(['animated', 'fade_in']).off('animationend');
            });
        } else {
            $askQuestionBanner.addClass(['animated', 'fade_out']).on('animationend', () => {
                $askQuestionBanner.removeClass(['animated', 'fade_out', 'active']).off('animationend');
            });
        }
    });
};

export default init();
